module.exports = __webpack_public_path__ + "static/school_bg@2x-81145c006d9735bb8966549ed9e438c6.jpg";